import axiosInstance from "../AxiosInstance";
import {
  ACTIVE_FLAG_POSTING_LIST,
  ADD_COHOSTS,
  BLOCK_USER,
  DASHBOARD,
  DELETE_USERS,
  EVENT_GRAPH,
  EVENT_LISTING_TASKS,
  EVENTS,
  FAQ,
  FLAG_POSTING_LIST,
  JOB_CATEGORY_LIST,
  JOB_DETAILS,
  JOB_POSTING_LIST,
  NEW_WEDDING_SUBSCRIPTIONSTATUS,
  NEW_WEDDING_REQUEST,
  NEWUSERS,
  PHOTO_GALLERY,
  POLICY,
  PRICE,
  REQUEST_PLAN_CHANGE,
  REVENUE_GRAPH,
  SERVICE_CATEGORY_LIST,
  SERVICE_DETAILS,
  SERVICE_POSTING_LIST,
  SUBSCRIPTION,
  SUBSCRIPTIONSTATUS,
  TEMPALTES,
  USER_COHOST,
  USER_DASHBOARD,
  USER_EVENT,
  USER_EVENT_GUESTS,
  USER_GRAPH,
  USER_GUESTS,
  USER_SUB_EVENTS,
  USER_TASKS,
  USERDETAIL,
  USERLIST,
  GET_PARTNER,
  UPLOADIMAGE,
  UPDATE_PARTNER,
  GET_PARTNER_STATS,
  COMBINEDPACKAGE,
  PARTNER_CRUD,
  GET_PARTNER_ANALYTICS,
  GET_PARTNER_REVENUE,
  GET_PARTNER_REVENUE_GRAPH,
  GET_PACKAGE_REVENUE_GRAPH,
  PACKAGE_STATS,
  PARTNER_HOST,
  UPDATE_PARTNER_WHATSAPP_LIMIT,
  ASSIGN_PARTNER_PLAN,
  WHATSAPP_PACKAGE,
  GET_WHATSAPP_PACKAGE_REVENUE_GRAPH,
  GET_TOTAL_REVENUE_GRAPH,
  GET_ACQUISITION_SOURCE_GRAPH,
  GET_HOST_CREATED_GRAPH,
  WHATAPP_ASSIGN,
  GET_PARTNER_NOTIFICATIONS,
  MARK_NOTIFICATION_READ,
  GET_INACTIVE_PARTNERS_NO_LOGIN,
  GET_INACTIVE_PARTNERS_NO_WEDDING,
  HARD_DELETE_PARTNER,
  HARD_DELETE_USER,
  PLANCREATION,
  GET_SUBSCRIPTION_STATS,
  HOST_WEDDINGS,
  ASSIGNPLAN,
} from "./UserEndpoint";

export function getUserList(page, limit, search, sortByPlan, date, endDate, status, sortBy, sortOrder, userType) {
  return axiosInstance.get(
    `${USERLIST}?page=${page}&limit=${limit}` +
    `${search ? `&search=${search}` : ""}` +
    `${sortByPlan ? `&sortByPlan=${sortByPlan}` : ""}` +
    `${date ? `&startDate=${date}` : ""}` +
    `${endDate ? `&endDate=${endDate}` : ""}` +
    `${status ? `&status=${status}` : ""}` +
    `${sortBy ? `&sortBy=${sortBy}` : ""}` +
    `${sortOrder ? `&sortOrder=${sortOrder}` : ""}` +
    `${userType ? `&userType=${userType}` : ""}`
  );
}
export function getDisableUserList(page, limit, search, sortByPlan, date, endDate, status, sortBy, sortOrder, userType) {
  return axiosInstance.get(
    `${USERLIST}?page=${page}&limit=${limit}` +
    `${search ? `&search=${search}` : ""}` +
    `${sortByPlan ? `&sortByPlan=${sortByPlan}` : ""}` +
    `${date ? `&startDate=${date}` : ""}` +
    `${endDate ? `&endDate=${endDate}` : ""}` +
    `${status ? `&status=${status}` : ""}` +
    `${sortBy ? `&sortBy=${sortBy}` : ""}` +
    `${sortOrder ? `&sortOrder=${sortOrder}` : ""}` +
    `${userType ? `&userType=${userType}` : ""}`
  );
}


export function getUserDetail(id) {
  return axiosInstance.get(`${USERDETAIL}?userId=${id}`);
}

export function getUserCohosts(id, search, currentPage, limit) {
  return axiosInstance.get(
    `${USER_COHOST}?userId=${id}${currentPage ? `&page=${currentPage}` : ""}${limit ? `&limit=${limit}` : ""
    }${search ? `&search=${search}` : ""}`
  );
}

export function getUserGuests(id, search) {
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  if (id) params.append("userId", id);
  return axiosInstance.get(`${USER_GUESTS}?${params.toString()}`);
}


export function getUser_Guests(id, currentPage, limit, search, status) {
  const params = new URLSearchParams();
  if (currentPage) params.append("page", currentPage);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  if (id) params.append("userId", id);
  if (status) params.append("status", status);
  return axiosInstance.get(`/admin/user/guest/invites?${params.toString()}`);
}


export function getUserGuestsList(page, limit, search, date, endDate, sortBy, sortOrder) {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  if (date) params.append("startDate", date);
  if (endDate) params.append("endDate", endDate);
  if (sortBy) params.append("sortBy", sortBy);
  if (sortOrder) params.append("sortOrder", sortOrder);

  const url = `${USER_GUESTS}?${params.toString()}`;
  return axiosInstance.get(url);
}










export function getUserEventGuest(id, currentPage, limit, search, type) {
  // &${search ? `search=${search}` : ""}
  return axiosInstance.get(
    `${USER_EVENT_GUESTS}?eventId=${id}${currentPage ? `&page=${currentPage}` : ""
    }${limit ? `&limit=${limit}` : ""}${search ? `&search=${search}` : ""}${type ? `&sortBy=${type}` : ""
    }`
  );
}

export function getUserEvent(id, page, limit, date, end, type) {
  return axiosInstance.get(
    `${USER_EVENT}?userId=${id}${page ? `&page=${page}` : ""}${limit ? `&limit=${limit}` : ""
    }${date ? `&startDate=${date}` : ""
    }${end ? `&endDate=${end}` : ""
    }${type ? `&type=${type}` : ""}`
  );
}

export function getUserSubEvent(id1, id2) {
  return axiosInstance.get(`${USER_SUB_EVENTS}?userId=${id1}&eventId=${id2}`);
}

export function getEventSubEvents(id) {
  return axiosInstance.get(`${USER_SUB_EVENTS}?eventId=${id}`);
}

export function getUserTasks(id1, id2, currentPage, limit, search) {
  return axiosInstance.get(
    `${USER_TASKS}?userId=${id1}&eventId=${id2}&page=${currentPage}&limit=${limit}${search ? `&search=${search}` : ""
    }`
  );
}

export function updateUserTasks(taskId) {
  return axiosInstance.put(
    `/admin/user/tasks`,
    { taskId }   // sending as payload object
  );
}



export function getDashboardTemp() {
  return axiosInstance.get(`${USER_DASHBOARD}`);
}

export function getFAQS(search) {
  return axiosInstance.get(`${FAQ}`);
}

export function postFAQS(payload) {
  return axiosInstance.post(`${FAQ}`, payload);
}

export function updateFAQS(payload) {
  return axiosInstance.put(`${FAQ}`, payload);
}

export function deleteFAQS(id) {
  return axiosInstance.delete(`${FAQ}?faqId=${id}`);
}

export function getNEWUSERS(page, limit, search, key, start, end) {
  return axiosInstance.get(
    `${NEWUSERS}?page=${page}&limit=${limit}&search=${search}&type=${key}${start ? `&startDate=${start}` : ""}${end ? `&endDate=${end}` : ""}`
  );
}



export function changeRequestUserPlan(data) {
  return axiosInstance.put(
    `${REQUEST_PLAN_CHANGE}`, data
  );
}
export function deleteRequestUserPlan(id) {
  return axiosInstance.delete(
    `${REQUEST_PLAN_CHANGE}?userId=${id}`
  );
}

export function postNewWeddingRequest(data) {
  return axiosInstance.post(
    `${NEW_WEDDING_REQUEST}`, data
  );
}





export function getEvent(page, limit, filterType, date, end, sortBy, sortOrder) {
  return axiosInstance.get(
    `${EVENTS}?page=${page}&limit=${limit}${filterType ? `&type=${filterType}` : ""
    }${date ? `&startDate=${date}` : ""}${end ? `&endDate=${end}` : ""}${sortBy ? `&sortBy=${sortBy}` : ""
    }${sortOrder ? `&sortOrder=${sortOrder}` : ""}`
  );
}
export function getEventTasks(page, limit, id, search) {
  return axiosInstance.get(`${EVENT_LISTING_TASKS}?page=${page}&limit=${limit}&eventId=${id}&search=${search}`);
}

export function changeSUBSCRIPTION(paylaod) {
  return axiosInstance.put(`${SUBSCRIPTIONSTATUS}`, paylaod);
}
export function changeNewWeddingSubscription(paylaod) {
  return axiosInstance.put(`${NEW_WEDDING_SUBSCRIPTIONSTATUS}`, paylaod);
}

export function getTEMPLATES(page, limit, eventId, name) {
  return axiosInstance.get(`${TEMPALTES}?page=${page}&limit=${limit}&event=${eventId}&name=${name}`);
}
export function addTEMPLATES(payload) {
  return axiosInstance.post(`${TEMPALTES}`, payload);
}
export function updateTEMPLATES(payload) {
  return axiosInstance.put(`${TEMPALTES}`, payload);
}
export function deleteTEMPLATES(id) {
  return axiosInstance.delete(`${TEMPALTES}?templateId=${id}`);
}

//subscroption
export function getSUBSCRIPTION() {
  return axiosInstance.get(`${SUBSCRIPTION}`);
}
export function getPackage(isCombinedSubscription = false) {
  if (isCombinedSubscription) {
    return axiosInstance.get(`${SUBSCRIPTION}?isCombinedSubscription=${true}&isPartnerSubscription=${true}`);
  }
  return axiosInstance.get(`${SUBSCRIPTION}?isPartnerSubscription=${true}`);
}
export function getPackageData() {
  return axiosInstance.get(`${SUBSCRIPTION}?isPartnerSubscription=${true}`);
}



export function postSUBSCRIPTION(payload) {
  return axiosInstance.post(`${SUBSCRIPTION}`, payload);
}
export function postPlan(payload) {
  return axiosInstance.post(`${PLANCREATION}`, payload);
}
export function putPlan(payload) {
  return axiosInstance.put(`${PLANCREATION}`, payload);
}
export function postCombinedPackage(payload) {
  return axiosInstance.post(`${COMBINEDPACKAGE}`, payload);
}
export function putCombinedPackage(payload) {
  return axiosInstance.put(`${COMBINEDPACKAGE}`, payload);
}
export function updatetSUBSCRIPTION(payload) {
  return axiosInstance.put(`${SUBSCRIPTION}`, payload);
}
export function deleteSUBSCRIPTION(id) {
  return axiosInstance.delete(`${SUBSCRIPTION}?subscriptionId=${id}`);
}
export function deletePlan(id) {
  return axiosInstance.delete(`${PLANCREATION}?subscriptionId=${id}`);
}

// export function getUserSubEvent(id1, id2) {
//   return axiosInstance.post(`${USER_SUB_EVENTS}`, {
//     userId: id1,
//     eventId: id2
//   });
// }

export function getJobCategoryList(page, limit, search) {
  return axiosInstance.get(
    `${JOB_CATEGORY_LIST}?page=${page}&limit=${limit}&search=${search}`
  );
}

export function getServiceCategoryList(page, limit, search) {
  return axiosInstance.get(
    `${SERVICE_CATEGORY_LIST}?page=${page}&limit=${limit}&search=${search}`
  );
}

export function postJobCategory(postData) {
  return axiosInstance.post(JOB_CATEGORY_LIST, postData);
}

export function postServiceCategory(postData) {
  return axiosInstance.post(SERVICE_CATEGORY_LIST, postData);
}

export function deleteJobCategory(id) {
  return axiosInstance.delete(`${JOB_CATEGORY_LIST}?categoryId=${id}`);
}

export function deleteServiceCategory(id) {
  return axiosInstance.delete(`${SERVICE_CATEGORY_LIST}?categoryId=${id}`);
}

export function updateJobCategory(postData) {
  return axiosInstance.put(`${JOB_CATEGORY_LIST}`, postData);
}

export function updateServiceCategory(postData) {
  return axiosInstance.put(`${SERVICE_CATEGORY_LIST}`, postData);
}

export function jobPostingData(currentPage, search) {
  return axiosInstance.get(
    `${JOB_POSTING_LIST}?page=${currentPage}&search=${search}`
  );
}

export function flagPostingData(currentPage) {
  return axiosInstance.get(`${FLAG_POSTING_LIST}?page=${currentPage}`);
}

export function activeJobServicePostingData(data) {
  return axiosInstance.put(`${ACTIVE_FLAG_POSTING_LIST}`, data);
}

export function deleteJobPostingData(id) {
  return axiosInstance.delete(`${JOB_POSTING_LIST}?jobId=${id}`);
}

export function servicePostingData(currentPage, search) {
  return axiosInstance.get(
    `${SERVICE_POSTING_LIST}?page=${currentPage}&search=${search}`
  );
}

export function deleteServicePostingData(id) {
  return axiosInstance.delete(`${SERVICE_POSTING_LIST}?serviceId=${id}`);
}

export function getJobDetails(id) {
  return axiosInstance.get(`${JOB_DETAILS}?jobId=${id}`);
}

export function getServiceDetails(id) {
  return axiosInstance.get(`${SERVICE_DETAILS}?serviceId=${id}`);
}

export function blockUser(data) {
  return axiosInstance.post(`${BLOCK_USER}`, data);
}

export function getPrice() {
  return axiosInstance.get(`${PRICE}`);
}

export function getDashboard(startDate, endDate) {
  return axiosInstance.get(
    `${DASHBOARD}?${startDate ? `startDate=${startDate}` : ""}&${endDate ? `endDate=${endDate}` : ""
    }`
  );
}

export function updatePrice(data) {
  return axiosInstance.put(`${PRICE}`, data);
}

//get polies / anout us /

export function getPolicies(type) {
  return axiosInstance.get(`${POLICY}?&type=${type}`);
}

export function postPolicies(payload) {
  return axiosInstance.post(`${POLICY}`, payload);
}

export function addCohost(payload) {
  return axiosInstance.post(`${ADD_COHOSTS}`, payload);
}

export function deleteUsers(id) {
  return axiosInstance.delete(`${DELETE_USERS}?&userId=${id}`);
}

//edit user
export function editHost(data) {
  return axiosInstance.put(`${DELETE_USERS}`, data);
}

export function editHostSubscription(data) {
  return axiosInstance.put(`${DELETE_USERS}/subscription/plan`, data);
}

export function assignPlan(data) {
  return axiosInstance.put(`${ASSIGNPLAN}`, data);
}

///update events

export function editUserEvents(data) {
  return axiosInstance.put(`${EVENTS}`, data);
}

//cahnge events guest status
export function updateGuestStatus(data) {
  return axiosInstance.put(`${DELETE_USERS}/rsvpInvites`, data);
}

export function getUserGraph() {
  return axiosInstance.get(`${USER_GRAPH}`);
}

export function getEventGraph() {
  return axiosInstance.get(`${EVENT_GRAPH}`);
}

export function getRevenueGraph() {
  return axiosInstance.get(`${REVENUE_GRAPH}`);
}

export function getPhoto(page, limit, eventId) {
  return axiosInstance.get(`${PHOTO_GALLERY}?page=${page}&limit=${limit}&eventId=${eventId}`);
}

export function getEventById(eventId) {
  return axiosInstance.get(`/admin/user/event/detail?eventId=${eventId}`);
}

export function getHostAndGuestGraph(type) {
  return axiosInstance.get(`/admin/graph/hostAndGuest?type=${type}`);
}

export function getActiveHostAndGuestGraph(type) {
  return axiosInstance.get(`/admin/graph/acticeHostAndGuest?type=${type}`);
}

export function getRsvpsAndMessagesGraph(type) {
  return axiosInstance.get(`/admin/graph/rsvpsAndMessages?type=${type}`);
}

export function getInvitesGraph(type) {
  return axiosInstance.get(`/admin/graph/invites?type=${type}`);
}

export function getPhotoSharingGraph(type) {
  return axiosInstance.get(`/admin/graph/photoSharing?type=${type}`);
}

export function getTasksGraph(type) {
  return axiosInstance.get(`/admin/graph/task?type=${type}`);
}

export function getSubscriptionGraph() {
  return axiosInstance.get(`/admin/graph/subscription`);
}

export function getPartner(pageOrPayload, limit, status, search, packageVal, startDate, endDate, sortStatus, sortByObj, isBlockedParam) {
  if (typeof pageOrPayload === "object" && pageOrPayload !== null) {
    const isBlocked = pageOrPayload.isBlocked !== undefined ? pageOrPayload.isBlocked : isBlockedParam;
    const query = isBlocked !== undefined && isBlocked !== null ? `?isBlocked=${isBlocked}` : "";
    return axiosInstance.post(`${GET_PARTNER}${query}`, pageOrPayload);
  }

  const body = {};
  if (pageOrPayload !== undefined && pageOrPayload !== null) body.page = pageOrPayload;
  if (limit) body.limit = limit;
  if (status) body.adminApproval = status;
  if (search) body.search = search;
  if (packageVal) body.package = packageVal;
  if (startDate) body.startDate = startDate;
  if (endDate) body.endDate = endDate;
  if (sortStatus) body.status = sortStatus;
  if (sortByObj && typeof sortByObj === "object") body.sortBy = sortByObj;

  const isBlocked = isBlockedParam !== undefined ? isBlockedParam : body.isBlocked;
  const query = isBlocked !== undefined && isBlocked !== null ? `?isBlocked=${isBlocked}` : "";

  return axiosInstance.post(`${GET_PARTNER}${query}`, body);
}

export function createPartner(payload) {
  return axiosInstance.post(`${PARTNER_CRUD}`, payload, {
    headers: { "Content-Type": "application/json" },
  });
}
export function updatePartner(payload) {
  return axiosInstance.post(`${PARTNER_CRUD}/approved`, payload, {
    headers: { "Content-Type": "application/json" },
  });
}

export function updatePartnerDetail(payload) {
  return axiosInstance.put(`${PARTNER_CRUD}`, payload, {
    headers: { "Content-Type": "application/json" },
  });
}
export function getPartnerDetail(id) {
  return axiosInstance.get(`${PARTNER_CRUD}/detail?partnerId=${id}`);
}
export function uploadImage(payload) {
  return axiosInstance.post(`${UPLOADIMAGE}`, payload);
}
export function getPartnerStats() {
  return axiosInstance.get(`${GET_PARTNER_STATS}`);
}
export function deleteParnter(id) {
  return axiosInstance.delete(`${PARTNER_CRUD}?partnerId=${id}`);
}
export function getPartnerAnalytics(startDate, endDate) {
  if (startDate && endDate) {
    return axiosInstance.get(`${GET_PARTNER_ANALYTICS}?startDate=${startDate}&endDate=${endDate}`);
  }
  return axiosInstance.get(`${GET_PARTNER_ANALYTICS}`);
}

export function getPartnerRevenue(startDate, endDate) {
  return axiosInstance.get(`${GET_PARTNER_REVENUE_GRAPH}?startDate=${startDate}&endDate=${endDate}`);
}
export function getPackageRevenue(startDate, endDate, partnerId) {
  if (partnerId) {
    return axiosInstance.get(`${GET_PACKAGE_REVENUE_GRAPH}?startDate=${startDate}&endDate=${endDate}&packageId=${partnerId}`);
  }
  return axiosInstance.get(`${GET_PACKAGE_REVENUE_GRAPH}?startDate=${startDate}&endDate=${endDate}`);
}

export function getWhatsAppPackageRevenue(startDate, endDate, whatsappPlanId) {
  if (whatsappPlanId) {
    return axiosInstance.get(`${GET_WHATSAPP_PACKAGE_REVENUE_GRAPH}?startDate=${startDate}&endDate=${endDate}&whatsappPlanId=${whatsappPlanId}`);
  }
  return axiosInstance.get(`${GET_WHATSAPP_PACKAGE_REVENUE_GRAPH}?startDate=${startDate}&endDate=${endDate}`);
}

export function getTotalRevenueGraph(startDate, endDate) {
  return axiosInstance.get(`${GET_TOTAL_REVENUE_GRAPH}?startDate=${startDate}&endDate=${endDate}`);
}

export function getAcquisitionSourceGraph(startDate, endDate) {
  return axiosInstance.get(`${GET_ACQUISITION_SOURCE_GRAPH}?startDate=${startDate}&endDate=${endDate}`);
}

export function getHostCreatedGraph(partnerId, startDate, endDate) {
  return axiosInstance.get(`${GET_HOST_CREATED_GRAPH}?partnerId=${partnerId}&startDate=${startDate}&endDate=${endDate}`);
}

export function getPackageStats() {
  return axiosInstance.get(`${PACKAGE_STATS}`);
}

export function getPartnerHost(id, page, limit) {
  return axiosInstance.get(`${PARTNER_HOST}?partnerId=${id}&page=${page - 1}&limit=${limit}`);
}

export function updatePartnerWhatsappLimit(payload) {
  return axiosInstance.put(UPDATE_PARTNER_WHATSAPP_LIMIT, payload);
}

export function assignPartnerPlan(payload) {
  return axiosInstance.put(ASSIGN_PARTNER_PLAN, payload);
}

export function getWhatsAppPackage() {
  return axiosInstance.get(WHATSAPP_PACKAGE);
}
export function postWhatsAppPackage(payload) {
  return axiosInstance.post(WHATSAPP_PACKAGE, payload);
}
export function putWhatsAppPackage(payload) {
  return axiosInstance.put(WHATSAPP_PACKAGE, payload);
}
export function deleteWhatsAppPackage(id) {
  return axiosInstance.delete(`${WHATSAPP_PACKAGE}?whatsappPlanId=${id}`);
}

export function WhatsAppPackageAssign(payload) {
  return axiosInstance.post(WHATAPP_ASSIGN, payload);
}

export function createHost(payload) {
  return axiosInstance.post("/admin/user", payload);
}

export function getPartnerNotifications(page = 0, limit = 10, isRead = null) {
  let url = `${GET_PARTNER_NOTIFICATIONS}?page=${page}&limit=${limit}`;
  if (isRead !== null && isRead !== undefined && isRead !== "") {
    url += `&isRead=${isRead}`;
  }
  return axiosInstance.get(url);
}

export function markNotificationAsRead(notificationId) {
  const payload = notificationId ? { notificationId } : {};
  return axiosInstance.post(MARK_NOTIFICATION_READ, payload);
}

export function getInactivePartnersNoLogin(pageOrPayload = 0, limit = 10, search = "", sortFieldParam = "", sortOrderParam = "asc", subscriptionIdParam = "") {
  let page = 0;
  let lim = 10;
  let qSearch = "";
  let field = "";
  let order = "asc";
  let subscriptionId = "";

  if (typeof pageOrPayload === "object" && pageOrPayload !== null) {
    page = pageOrPayload.page ?? 0;
    lim = pageOrPayload.limit ?? 10;
    qSearch = pageOrPayload.search || "";
    if (pageOrPayload.sortBy && typeof pageOrPayload.sortBy === "object") {
      field = pageOrPayload.sortBy.field || "";
      order = pageOrPayload.sortBy.order || "asc";
      subscriptionId = pageOrPayload.sortBy.subscriptionId || "";
    }
  } else {
    page = pageOrPayload ?? 0;
    lim = limit ?? 10;
    qSearch = search || "";
    field = sortFieldParam || "";
    order = sortOrderParam || "asc";
    subscriptionId = subscriptionIdParam || "";
  }

  let url = `${GET_INACTIVE_PARTNERS_NO_LOGIN}?page=${page}&limit=${lim}`;
  if (qSearch) {
    url += `&search=${encodeURIComponent(qSearch)}`;
  }
  if (field) {
    url += `&sortBy[field]=${encodeURIComponent(field)}`;
    url += `&sortBy[order]=${encodeURIComponent(order || "asc")}`;
    if (subscriptionId) {
      url += `&sortBy[subscriptionId]=${encodeURIComponent(subscriptionId)}`;
    }
  }

  return axiosInstance.get(url);
}

export function getInactivePartnersNoWedding(pageOrPayload = 0, limit = 10, search = "", sortFieldParam = "", sortOrderParam = "asc", subscriptionIdParam = "") {
  let page = 0;
  let lim = 10;
  let qSearch = "";
  let field = "";
  let order = "asc";
  let subscriptionId = "";

  if (typeof pageOrPayload === "object" && pageOrPayload !== null) {
    page = pageOrPayload.page ?? 0;
    lim = pageOrPayload.limit ?? 10;
    qSearch = pageOrPayload.search || "";
    if (pageOrPayload.sortBy && typeof pageOrPayload.sortBy === "object") {
      field = pageOrPayload.sortBy.field || "";
      order = pageOrPayload.sortBy.order || "asc";
      subscriptionId = pageOrPayload.sortBy.subscriptionId || "";
    }
  } else {
    page = pageOrPayload ?? 0;
    lim = limit ?? 10;
    qSearch = search || "";
    field = sortFieldParam || "";
    order = sortOrderParam || "asc";
    subscriptionId = subscriptionIdParam || "";
  }

  let url = `${GET_INACTIVE_PARTNERS_NO_WEDDING}?page=${page}&limit=${lim}`;
  if (qSearch) {
    url += `&search=${encodeURIComponent(qSearch)}`;
  }
  if (field) {
    url += `&sortBy[field]=${encodeURIComponent(field)}`;
    url += `&sortBy[order]=${encodeURIComponent(order || "asc")}`;
    if (subscriptionId) {
      url += `&sortBy[subscriptionId]=${encodeURIComponent(subscriptionId)}`;
    }
  }

  return axiosInstance.get(url);
}

export function hardDeletePartner(partnerId) {
  return axiosInstance.post(HARD_DELETE_PARTNER, { partnerId });
}

export function hardDeleteUser(userId) {
  return axiosInstance.post(HARD_DELETE_USER, { userId });
}

export function getSubscriptionStatsApi(startDate, endDate) {
  let url = `${GET_SUBSCRIPTION_STATS}`;
  const params = [];
  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);
  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }
  return axiosInstance.get(url);
}


export function getHostWeddings(hostId, page, limit) {
  return axiosInstance.get(`${HOST_WEDDINGS}?userId=${hostId}&page=${page}&limit=${limit}`);
}

